module.exports = __webpack_public_path__ + "img/icon_bell.28bcd54a.fc20110c.svg";